import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, Music } from 'lucide-react';
import AppKontenTab from './AppKontenTab';
import KennungenTab from './KennungenTab';
import AktuellesTab from './AktuellesTab';
import DokumenteTab from './DokumenteTab';
import VeranstaltungenTab from './VeranstaltungenTab';
import PinnwandTab from './PinnwandTab';
import NachrichtenTab from './NachrichtenTab';
import AbgleichTab from './AbgleichTab';

const TABS = [
  { k: 'app-konten', label: 'App-Konten' },
  { k: 'kennungen', label: 'Kennungen' },
  { k: 'nachrichten', label: 'Nachrichten' },
  { k: 'pinnwand', label: 'Pinnwand' },
  { k: 'aktuelles', label: 'Aktuelles' },
  { k: 'dokumente', label: 'Dokumente' },
  { k: 'dateien', label: 'Dateien' },
  { k: 'veranstaltungen', label: 'Veranstaltungen' },
  { k: 'abgleich', label: 'Abgleich' },
];
const READY = new Set(['app-konten', 'kennungen', 'nachrichten', 'pinnwand', 'aktuelles', 'dokumente', 'dateien', 'veranstaltungen', 'abgleich']);

export default function AppVerwaltungPage() {
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab') || 'app-konten');

  const switchTab = (k) => { setTab(k); setParams({ tab: k }, { replace: true }); };

  return (
    <div className="h-screen bg-slate-100 flex flex-col" data-testid="app-verwaltung-page">
      <div className="bg-white border-b border-slate-200 flex items-center px-4">
        <button onClick={() => nav('/')} data-testid="app-verwaltung-close"
                className="flex flex-col items-center gap-0.5 py-2 pr-5 text-xs text-slate-500 hover:text-slate-800">
          <XCircle className="w-6 h-6 text-brand-red" />
          Schließen
        </button>
        <div className="flex-1 flex items-center overflow-x-auto">
          {TABS.map((t) => (
            <button key={t.k} onClick={() => switchTab(t.k)}
                    data-testid={`app-verwaltung-tab-${t.k}`}
                    className={`px-5 py-4 text-sm whitespace-nowrap border-b-2 transition-colors ${
                      tab === t.k ? 'border-brand-red text-slate-900 font-semibold' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
              {t.label}
            </button>
          ))}
        </div>
        <div className="hidden md:flex items-center gap-1.5 pl-4 text-brand-red font-bold">
          <Music className="w-5 h-5" /> App
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        {tab === 'app-konten' && <AppKontenTab />}
        {tab === 'kennungen' && <KennungenTab />}
        {tab === 'aktuelles' && <AktuellesTab />}
        {tab === 'dokumente' && <DokumenteTab kind="dokumente" />}
        {tab === 'dateien' && <DokumenteTab kind="dateien" />}
        {tab === 'veranstaltungen' && <VeranstaltungenTab />}
        {tab === 'pinnwand' && <PinnwandTab />}
        {tab === 'nachrichten' && <NachrichtenTab />}
        {tab === 'abgleich' && <AbgleichTab />}
        {!READY.has(tab) && (
          <div className="h-full flex items-center justify-center">
            <p className="text-slate-400 text-sm" data-testid="app-verwaltung-placeholder">
              „{TABS.find((t) => t.k === tab)?.label}“ folgt im nächsten Ausbauschritt.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
